var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_26)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.87012 24.5071C10.6468 24.5071 11.2764 23.8775 11.2764 23.1008C11.2764 22.3242 10.6468 21.6946 9.87012 21.6946C9.09347 21.6946 8.46387 22.3242 8.46387 23.1008C8.46387 23.8775 9.09347 24.5071 9.87012 24.5071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5576 26.3821C15.3343 26.3821 15.9639 25.7525 15.9639 24.9758C15.9639 24.1992 15.3343 23.5696 14.5576 23.5696C13.781 23.5696 13.1514 24.1992 13.1514 24.9758C13.1514 25.7525 13.781 26.3821 14.5576 26.3821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1826 24.5071C20.9593 24.5071 21.5889 23.8775 21.5889 23.1008C21.5889 22.3242 20.9593 21.6946 20.1826 21.6946C19.406 21.6946 18.7764 22.3242 18.7764 23.1008C18.7764 23.8775 19.406 24.5071 20.1826 24.5071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93262 29.1946C9.70927 29.1946 10.3389 28.565 10.3389 27.7883C10.3389 27.0117 9.70927 26.3821 8.93262 26.3821C8.15597 26.3821 7.52637 27.0117 7.52637 27.7883C7.52637 28.565 8.15597 29.1946 8.93262 29.1946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2451 29.1946C20.0218 29.1946 20.6514 28.565 20.6514 27.7883C20.6514 27.0117 20.0218 26.3821 19.2451 26.3821C18.4685 26.3821 17.8389 27.0117 17.8389 27.7883C17.8389 28.565 18.4685 29.1946 19.2451 29.1946Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5079 3.41248C15.0445 3.94576 12 6 11.5341 8.8437C10.8258 8.603 10.0737 8.51929 9.32981 8.59839C8.58594 8.67748 7.86819 8.91749 7.22637 9.30175C6.58455 9.686 6.03402 10.2053 5.61299 10.8236C5.19196 11.442 4.91051 12.1445 4.78817 12.8825C4.66583 13.6205 4.70554 14.3762 4.90453 15.0973C5.10352 15.8185 5.45703 16.4876 5.94053 17.0584C6.42403 17.6292 7.02594 18.088 7.7045 18.4029C8.38305 18.7178 9.12199 18.8813 9.87005 18.882H19.2451C20.8026 18.8807 22.3257 18.4235 23.6263 17.5667C24.927 16.7099 25.9483 15.491 26.5643 14.0604C27.1802 12.6299 27.3639 11.0503 27.0925 9.51657C26.8211 7.98287 26.1066 6.56218 25.0372 5.42984C23.9678 4.2975 22.5902 3.50306 21.0745 3.14457C19.5588 2.78607 17.9713 2.87921 16.5079 3.41248Z",
    stroke: "black",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.963867)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.963867 0.13208)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnow);
export default __webpack_public_path__ + "static/media/snow.fd895f7c31f68708188485522968167a.svg";
export { ForwardRef as ReactComponent };